import { JwtClient } from "utils/jwtClient";

export type GetApplicationJourneyProps = {
  applicationJourneyRef: string;
  jwtClient: JwtClient;
};

export const getApplicationJourney = async ({
  applicationJourneyRef,
  jwtClient,
}: GetApplicationJourneyProps): Promise<ApplicationJourney> => {
  const response = await jwtClient.apiCall({
    path: applicationJourneyRef,
  });
  const {
    data: { attributes },
  } = await response.json();

  return attributes;
};
